module.exports = __webpack_public_path__ + "img/furniture_variant_1x.64f7737.webp";